<div class="header" fxLayout="column" fxLayoutAlign="start stretch" #content>
	<div fxLayout="row" class="header-container" fxLayoutAlign="space-between center" fxFlexFill fxLayoutGap="40px"
		fxLayoutGap.xs="7px" fxLayoutGap.gt-xs="17px">
		<div fxLayout="row" fxLayoutAlign="start center" class="logo-contain">
			<button class="toggle-btn" mat-icon-button fxLayoutAlign.xs="center center" (click)="onSidenavToggle()">
				<mat-animated-icon [start]="'menu'" [end]="'clear'" colorStart="none" colorEnd="none" [animate]="sideNavState"
					[animateFromParent]="true"></mat-animated-icon>
			</button>
			<div fxLayout="row" fxLayoutAlign="start stretch" fxLayoutGap="8px" fxLayoutGap.xs="5px">
				<div fxLayout="row" fxLayoutAlign="center center">
					<!-- <img (click)="routeHome()"
						[src]="(detectDevice?.resolutionState$?.value?.deviceType !== 'mobile') ? 'assets/img/logo.png' : 'assets/img/logo.png'"
						class="logo" [ngClass]="{'mini': detectDevice?.resolutionState$?.value?.deviceType === 'mobile'}"> -->
					<!-- <mat-icon svgIcon="unifi_logo"></mat-icon> -->
					<div class="logo" (click)="routeHome()">
						<mat-icon class="logo-icon" svgIcon="bility_logo" *ngIf="appInit.configuration.INSTANCE==='BILITY'"
							[ngClass]="{'mini': detectDevice?.resolutionState$?.value?.deviceType === 'mobile'}"></mat-icon>
							
								<img *ngIf="appInit.configuration.INSTANCE==='VIZISTAX'" class="logo-icon-vizi" src="assets/img/vizistax.png" alt="" [ngClass]="{'mini': detectDevice?.resolutionState$?.value?.deviceType === 'mobile'}"/>
							
							
					</div>
				</div>
				<!-- <ng-container *ngIf="currentUser?.profile?.company?.name"> -->
				<mat-divider class="custom-divider" [vertical]="'true'"></mat-divider>
				<div fxLayout="row" fxLayoutAlign="center center">
					<ng-container *ngIf="[null, undefined, ''].includes(currentUser?.companyLogo); else companyLogo">
						<h4 class="title">{{currentUser?.companyName}}</h4>
					</ng-container>
					<ng-template #companyLogo>
						<div class="client-logo" fxLayout="column" fxLayoutAlign="start stretch">
							<img class="client-img" [src]="currentUser?.companyLogo" (error)="gfService.setErrorImage($event, 'man')"
								[alt]="currentUser?.companyName">
						</div>
					</ng-template>
				</div>
				<!-- </ng-container> -->
			</div>
		</div>
		<div fxFlex="1 1 auto" fxHide.sm fxHide.xs fxLayout="column" fxLayoutAlign="start stretch" class="search-field">
			<ng-container [ngTemplateOutlet]="search"></ng-container>
		</div>
		<div class="icons-container" fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="20px"
			fxLayoutGap.xs="0px" fxLayoutAlign.xs="center center">
			<div fxLayout="row" fxLayoutAlign="space-between center">
				<div class="universal-search">
					<button mat-icon-button fxHide fxShow.sm fxShow.xs (click)="showSearch = !showSearch">
						<mat-icon>
							search
						</mat-icon>
					</button>
				</div>
			</div>
			<div fxLayout="row" fxLayoutAlign="space-between center">
				<div class="universal-creation">
					<!-- <ng-container *ngIf="detectDevice?.resolutionState$?.value?.deviceType === 'desktop'">
						<button mat-stroked-button #addBeadBtn class="share-btn" (click)="addBead(addBeadBtn)">
							<mat-icon svgIcon="contribution"></mat-icon><span>Knowledge Bead</span>
						</button>
					</ng-container>
					<ng-container *ngIf="detectDevice?.resolutionState$?.value?.deviceType !== 'desktop'">
						<button mat-icon-button #addBeadBtn class="share-icon-btn" (click)="addBead(addBeadBtn)">
							<mat-icon svgIcon="contribution"></mat-icon>
						</button>
					</ng-container> -->
					<ng-container *ngIf="detectDevice?.resolutionState$?.value?.deviceType === 'desktop'">
						<button mat-stroked-button class="share-btn" appClickOutSide [template]="creation" [position]="'bottom end'"
							[disabled]="!creationList?.length" [additionalOptions]="{'extraPX': 10}" [close]="closeTemplate"
							(isOpen)="closeTemplate = false">
							<mat-icon svgIcon="post"></mat-icon><span>{{ locale.translate('post') }}</span>
						</button>
					</ng-container>
					<ng-container *ngIf="detectDevice?.resolutionState$?.value?.deviceType !== 'desktop'">
						<button mat-icon-button class="share-icon-btn" appClickOutSide [template]="creation"
							[disabled]="!creationList?.length" [position]="'bottom end'" [additionalOptions]="{'extraPX': 10}"
							[close]="closeTemplate" (isOpen)="closeTemplate = false">
							<mat-icon svgIcon="post"></mat-icon>
						</button>
					</ng-container>
					<!-- <button mat-icon-button class="add-icon" appClickOutSide [template]="creation" [position]="'bottom end'"
						[additionalOptions]="{'extraPX': 10}">
						<mat-icon>add_circle</mat-icon>
					</button> -->
					<div fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="10px" fxFlex="1 1 300px"
						fxFlex.xs="1 1 250px" class="toggle-popup creation-panel" #creation>

						<!-- <div class="panel-content" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="10px"> -->
						<div class="creation-list" fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="10px">
							<ng-container *ngFor="let data of creationList">
								<ng-container *ngIf="data?.visible">
									<div class="creation-item cursor-pointer" matRipple (click)="triggerCreation(data)">
										<div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
											<mat-icon [svgIcon]="data?.svgIcon"></mat-icon>
											<div class="creation-caption">{{data?.caption}}
											</div>
										</div>
									</div>
								</ng-container>
							</ng-container>
						</div>
						<!-- </div> -->
					</div>
				</div>
			</div>
			<div fxLayout="row" fxLayoutAlign="space-between center" class="options" fxLayoutGap="15px" fxLayoutGap.xs="5px">
				<div class="universal-notification">
					<button mat-icon-button appClickOutSide [template]="notification" [position]="'bottom end'"
						(isOpen)="toggleNotification($event)" [close]="closeTemplate" [additionalOptions]="{'extraPX': 10}">
						<mat-icon [matBadge]="notificationCount" matBadgePosition="after" matBadgeColor="warn"
							[matBadgeHidden]="!notificationCount">
							notifications_none
						</mat-icon>
					</button>
					<div fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="10px" fxFlex="1 1 334px"
						fxFlex.xs="1 1 270px" class="toggle-popup notification-panel" #notification
						[ngStyle]="{'max-height': (notificationPanelHeight) ? notificationPanelHeight + 'px' : '450px'}">

						<div fxLayoutAlign="start center">
							<p class="panel-title">{{locale.translate('notifications')}}</p>
						</div>
						<div fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="5px" class="notification-list"
							appViewportAnalyzer type="bottom" (analyzedData)="loadMoreNotification($event)">
							<ng-container *ngIf="notifications?.length === 0 && !loader">
								<div class="list-item" fxFlex="0 0 auto" fxLayout="column" fxLayoutAlign="start stretch">
									<div fxLayoutAlign="center center">
										<p class="no-data">{{locale.translate('no_notification_for_you')}}</p>
									</div>
								</div>
							</ng-container>
							<ng-container *ngIf="notifications?.length">
								<ng-container
									*ngFor="let data of notifications; trackBy: gfService.trackByID.bind({'key': 'notificationID'})">
									<div class="list-item" [ngClass]="{'cursor-pointer': data?.cardAction?.link}"
										(click)="cardAction(data)">
										<div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px">
											<ng-container *ngIf="data?.thumbnail">
												<div fxFlex="0 0 25px" class="user-thumbnail" fxLayoutAlign="start start">
													<img [src]="data?.thumbnail" (error)="gfService.setErrorImage($event, 'man')"
														class="user-icon-small">
												</div>
											</ng-container>
											<div fxFlex="1 1" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="10px">
												<ng-container *ngIf="![null,undefined].includes(data?.message)">
													<div class="notification-caption"
														[innerHtml]="data?.message | handleBar : data?.payload | safeDom ">
													</div>
												</ng-container>
											</div>
										</div>
										<ng-container *ngIf="data?.action?.length">
											<div fxLayoutAlign="center center">
												<ng-container *ngFor="let action of data?.action">
													<ng-container [ngSwitch]="action?.type">
														<ng-container *ngSwitchCase="'button'">
															<button mat-stroked-button class="notification-btn" type="button"
																(click)="actions(action.actionType, data, {notification: notification})">
																{{action?.data}}
															</button>
														</ng-container>
													</ng-container>
												</ng-container>
											</div>
										</ng-container>
										<div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
											<ng-container *ngIf="data?.notificationStatus?.key === 'notSeen'">
												<span class="notification-dot"></span>
											</ng-container>
											<span class="notification-time">{{data?.effectiveDate}}</span>
										</div>
									</div>
								</ng-container>
							</ng-container>
							<ng-container *ngIf="loader">
								<div class="list-item loader" fxFlex="0 0 auto" fxLayout="column" fxLayoutAlign="start stretch"
									fxLayoutGap="10px" #loaderEl>
									<loader [loader]="loader" [type]="'general'" [classes]=""></loader>
								</div>
							</ng-container>

							<!-- <div class="list-item" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="10px">
                  <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px">
                    <div class="notification-caption">
                      <p>Submission of Knowledge card <b>Title</b> is due in 2 days.
                      </p>
                    </div>
                  </div>
                  <div fxLayoutAlign="center center">
                    <button mat-stroked-button class="notification-btn">Submit</button>
                  </div>
                  <div fxLayout="row" fxLayoutAlign="start center">
                    <p class="notification-time">2 h ago</p>
                  </div>
                </div>
                <div class="list-item" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="10px">

                  <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px">
                    <div class="user-thumbnail">
                      <img src="assets/img/dummyimg1.png" class="user-icon-small">
                    </div>
                    <div class="notification-caption">
                      <p><b>Username</b> has assigned a Knowledge Card <b>Title</b> to you
                      </p>
                    </div>
                  </div>
                  <div fxLayout="row" fxLayoutAlign="start center">
                    <p class="notification-time">2 h ago</p>
                  </div>
                </div>
                <div class="list-item" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="10px">

                  <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px">
                    <div class="user-thumbnail">
                      <img src="assets/img/dummyimg1.png" class="user-icon-small">
                    </div>
                    <div class="notification-caption">
                      <p><b>Username</b> has assigned a Knowledge Card <b>Title</b> to you
                      </p>
                    </div>
                  </div>
                  <div fxLayout="row" fxLayoutAlign="start center">
                    <p class="notification-time">Yesterday</p>
                  </div>
                </div>
                <div class="list-item" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="10px">

                  <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px">
                    <div class="user-thumbnail">
                      <img src="assets/img/dummyimg1.png" class="user-icon-small">
                    </div>
                    <div class="notification-caption">
                      <p><b>Username</b> has assigned a Knowledge Card <b>Title</b> to you
                      </p>
                    </div>
                  </div>
                  <div fxLayout="row" fxLayoutAlign="start center">
                    <p class="notification-time">2 h ago</p>
                  </div>
                </div>
                <div class="list-item" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="10px">

                  <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px">
                    <div class="user-thumbnail">
                      <img src="assets/img/dummyimg1.png" class="user-icon-small">
                    </div>
                    <div class="notification-caption">
                      <p><b>Username</b> has assigned a Knowledge Card <b>Title</b> to you
                      </p>
                    </div>
                  </div>
                  <div fxLayout="row" fxLayoutAlign="start center">
                    <p class="notification-time">2 h ago</p>
                  </div>
                </div> -->
						</div>
					</div>
				</div>
				<div class="universal-profile">
					<div appClickOutSide [template]="menuItem" [position]="'bottom end'" [close]="closeTemplate"
						[additionalOptions]="{'extraPX': 10}" class="cursor-pointer" (isOpen)="closeTemplate = false">
						<button mat-icon-button>
							<img [src]="currentUser?.profile?.profilePicURL" (error)="gfService.setErrorImage($event, 'man')">
						</button>
						<!-- <mat-icon class="silver-icon" svgIcon="badge"></mat-icon> -->
					</div>
					<div fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="0px" fxFlex="1 1 334px"
						class="toggle-popup profile-panel" #menuItem>
						<div class="profile-block" fxLayout="column" fxLayoutAlign="start stretch">
							<div class="profile-item user-namedtls" fxLayout="column" fxLayoutAlign="start stretch"
								fxLayoutGap="10px">
								<div class="user-fullname" fxLayoutAlign="center center">
									<p class="cursor-pointer" (click)="searchPeopleDetail(currentUser)">{{userName}}</p>
								</div>

								<div class="short-info" fxLayoutAlign="center center">
									<ng-container *ngFor="let info of shortInfo; let isLast = last">
										<span>{{info?.value}}</span>
										<ng-container *ngIf="!isLast">
											<span>|</span>
										</ng-container>
									</ng-container>
								</div>
							</div>
							<div class="profile-item pref-sign-info" fxLayoutAlign="center center">
								<button class="main-cancel" type="button" mat-button 
									(click)="bookmarkDetail()">
									{{locale.translate('bookmarks')}}
								</button>
							</div>
							<div class="profile-item pref-sign-info" fxLayoutAlign="center center">
								<button class="main-cancel" type="button" mat-button #updatePreferenceActionEl
									(click)="updatePreference(updatePreferenceActionEl)">
									{{locale.translate('preferences')}}
								</button>
							</div>
							<div class="profile-item  pref-sign-info" fxLayoutAlign="center center">
								<button class="main-cancel" type="button" mat-button (click)="logout()">
									{{locale.translate('sign_out')}}
								</button>
							</div>
							<div class="profile-item social-item" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="40px">
								<div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="5px">
									<p class="follow-info">{{locale.translate('follow_unifi_learning')}}</p>
									<mat-icon class="social-icon" svgIcon="linkedin">
									</mat-icon>
									<mat-icon class="social-icon youtube" svgIcon="youtube"></mat-icon>
								</div>
								<div class="primary-item" fxLayoutAlign="center center">
									<span>{{ locale.translate('privacy_policy')
										}}</span>
									<span>|</span>
									<span>{{ locale.translate('terms_use') }}</span>
									<span>|</span>
									<span>{{ locale.translate('feedback') }}</span>
								</div>

							</div>

						</div>
						<!--
						<app-chips type="legend"
							[data]="{imageSrc: currentUser?.profile?.profilePicURL, title: userName, shortInfo: shortInfo}"
							(title)="searchPeopleDetail(currentUser)">
						</app-chips> -->

						<!-- <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="10px">
							<button mat-stroked-button class="btn-silver silver">
								<mat-icon class="btn-icon" svgIcon="badge"></mat-icon>
								<span>{{ locale.translate('silver') }}</span>
							</button>
							<button mat-stroked-button class="btn-silver" [innerHtml]="locale.translate('profile_points') | handleBar : {'count':
								2345}"></button>
						</div> -->
						<!-- <div class="language" fxLayoutAlign="center center">
							<span [ngClass]="{'selected' : language === 'en'}" (click)="changeLanguage('en')">EN</span>
							<span [ngClass]="{'selected' : language === 'ta'}" (click)="changeLanguage('ta')">TA</span>
						</div>
						<div fxLayoutAlign="center center">
							<button mat-button disableRipple class="btn-signout"
								(click)="logout()">{{locale.translate('sign_out')}}</button>
						</div> -->
					</div>
				</div>
			</div>
		</div>
	</div>
	<ng-container *ngIf="!showSearch">
		<div fxLayout="row" fxLayoutAlign="center center" class="search-field mobile" [ngClass]="{'hide': showSearch}">
			<div fxFlex="1 1">
				<ng-container [ngTemplateOutlet]="search"></ng-container>
			</div>
			<button mat-icon-button (click)="showSearch = !showSearch">
				<mat-icon>clear</mat-icon>
			</button>
		</div>
	</ng-container>
</div>

<ng-template #search>
	<div fxLayoutGap="10px">
		<div class="search-input" fxFlex="1 1" fxLayout="row">
			<input type="text" matInput [placeholder]="searchField?.fieldPlaceholder" [matAutocomplete]="auto"
				[formControl]="searchControl" (keyup.enter)="resourceSearch()" (focusin)="reloadList()">
			<mat-autocomplete class="search-auto-complete" #auto="matAutocomplete" (optionSelected)="selected($event)">
				<ng-container
					*ngIf="searchLoader && !searchResult?.people?.length && !searchResult?.resource?.length && searchControl?.value">
					<mat-option disabled>
						<mat-spinner diameter="20"></mat-spinner>
					</mat-option>
				</ng-container>
				<ng-container *ngIf="searchResult?.resource?.length">
					<ng-container
						*ngFor="let data of searchResult?.resource; trackBy: gfService.trackByID.bind({'key': 'resourceID'})">
						<mat-option class="option-item">
							<app-content-image-card class="option-card" [type]="'minimal'" [record]="data"
								(click)="searchResourceDetail(data)">
							</app-content-image-card>
						</mat-option>
					</ng-container>
					<div class="list-link" fxLayout="row" fxLayoutAlign="end end">
						<p class="hyperlink" (click)="routeSearchType('resource')">
							{{locale.translate('resources')}}...
						</p>
					</div>
				</ng-container>
				<ng-container *ngIf="searchResult?.people?.length && searchResult?.resource?.length">
					<div>
						<mat-divider class="search-divider"></mat-divider>
					</div>
				</ng-container>
				<ng-container *ngIf="searchResult?.people?.length">
					<ng-container *ngFor="let data of searchResult?.people; trackBy: gfService.trackByID.bind({'key': 'userID'})">
						<mat-option class="option-item" (click)="searchPeopleDetail(data)">
							<div class="profile-search-card" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="15px">
								<!-- <app-chips type="legend" (title)="searchPeopleDetail(data)" (shortInfo)="searchPeopleDetail(data)"
									[data]="{imageSrc: data?.profilePicURL, title: data?.name, shortInfo: data?.shortInfo}">
								</app-chips> -->
								<div class="profile-item" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
									<div class="user-pic">
										<img [src]="(data?.profilePicURL) ? data?.profilePicURL : 'assets/img/man.png'"
											(error)="gfService.setErrorImage($event, 'man')">

									</div>
									<div class="user-details" fxFlex="1 1" fxFlex.xs="auto" fxLayout="column"
										fxLayoutAlign="start stretch" fxLayoutGap="0px">
										<span class="sub-text-1">{{data?.name}}</span>
										<!-- <div  fxFlex="1 1" fxFlex.xs="auto" fxLayout="row" fxLayoutAlign="start center"> -->

										<ng-container *ngIf="data?.shortInfo?.length">
											<div class="user-info" fxLayoutGap="3px" fxLayoutGap.xs="1px">
												<ng-container *ngFor="let info of data?.shortInfo; let index = index">
													<ng-container *ngIf="index === 0">
														<span><b>{{info?.value}}</b></span>
													</ng-container>
													<ng-container *ngIf="index !== 0">
														<span>{{info?.value}}</span>
													</ng-container>
													<ng-container *ngIf="index !== (data?.shortInfo?.length - 1)">
														<span>|</span>
													</ng-container>
												</ng-container>
											</div>
										</ng-container>
										<!-- </div> -->
									</div>
								</div>
							</div>
						</mat-option>
					</ng-container>
					<div class="list-link" fxLayout="row" fxLayoutAlign="end end">
						<p class="hyperlink" (click)="routeSearchType('people')">
							{{locale.translate('people')}}....
						</p>
					</div>
				</ng-container>

				<ng-container *ngIf="!searchResult?.people?.length && !searchResult?.resource?.length && searchControl?.value && searchApiStatus
					&& !searchLoader">
					<mat-option class="option-item" disabled>
						<div>
							{{locale.translate('no_results_found')}}
						</div>
					</mat-option>
				</ng-container>

				<!-- <ng-container>
					<mat-divider></mat-divider>
					<mat-option>
						<app-chips type="legend"
							[data]="{imageSrc: '', title: 'Mahish Sharma', shortInfo: [{value: 'Company'}, {value: 'Department'}, {value: 'Location'}]}">
						</app-chips>
					</mat-option>
					<mat-option>
						<app-chips type="legend"
							[data]="{imageSrc: '', title: 'Mahish Sharma', shortInfo: [{value: 'Company'}, {value: 'Department'}, {value: 'Location'}]}">
						</app-chips>
					</mat-option>
				</ng-container> -->

			</mat-autocomplete>
			<ng-container *ngIf="searchControl?.value">
				<div class="search-clear-icon">
					<mat-icon [matTooltip]="locale.translate('clear')" (click)="clearSearch()" class="cursor-pointer">clear
					</mat-icon>
				</div>
			</ng-container>
			<div class="search-icon">
				<mat-icon (click)="resourceSearch()" class="cursor-pointer">search</mat-icon>
			</div>
		</div>

	</div>
</ng-template>
